'use client';

import { Box, Heading } from "@chakra-ui/react";

export default function ShadowBox({ children, padding = '8', text = false, align = 'left' }) {
  return (
    <Box p={padding} boxShadow="lg" rounded="lg" textAlign={align}>
      { text !== false && (
        <Heading as="h2" fontFamily="inherit" fontWeight="300" fontSize={{ base: '1.6em', md: '2.1em' }} pb="8">
          { text }
        </Heading>
      )}

      { children }
    </Box>
  )
}
